export const GA_EVENTS = {
    FINANCE_CARD_CLICKED: "Finance_card_clicked",
    FINANCE_CARD_CLICKED_DETAILS: {
        event: "custom_event",
        eventCategory: "FF_volume_experiment",
        eventAction: "Finance_card_clicked",
        eventLabel: "{{Get_pre_approval_CDP_finance_banner}}"
    }
};

